import { Component, inject } from '@angular/core';
import {
    NotificationsEntity,
    NotificationsFacade,
} from '@qwyk/portals/data-access/notifications';

@Component({
    selector: 'qwyk-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent {
    private storeFacade = inject(NotificationsFacade);

    public notifications$ = this.storeFacade.allNotifications$;
    public loaded$ = this.storeFacade.loaded$;
    public selectedNotification$ = this.storeFacade.selectedNotification$;
    public canLoadPage$ = this.storeFacade.canLoadMoreNotifications$;
    public paginationInfo$ = this.storeFacade.paginationInfo$;
    public loadingPage$ = this.storeFacade.isLoadingPage$;
    public unread$ = this.storeFacade.unreadCount$;

    constructor() {
        this.storeFacade.loadNotifications();
    }

    onView(notification: NotificationsEntity) {
        this.storeFacade.toggleNotificationSelected(notification);
    }

    onDelete(notification: NotificationsEntity) {
        this.storeFacade.deleteNotification(notification);
    }

    onToggleRead(notification: NotificationsEntity) {
        this.storeFacade.toggleNotificationRead(notification);
    }

    onLoadMore() {
        this.storeFacade.loadMoreNotifications();
    }
}
